export default function checkPermission(permissionsHolder, permission) {
  return !!permissionsHolder?.permissions.includes(permission);
}
